var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Camera"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camera",
    clipPath: "url(#clip-Camera)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-0.75 5.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 3.333,
    cy: 3.333,
    r: 3.333,
    transform: "translate(78.594 26.944)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M26.928,13.611l5.884-7.36A10.006,10.006,0,0,1,40.621,2.5H60.879a10.006,10.006,0,0,1,7.809,3.751l5.884,7.36H88.528A12.221,12.221,0,0,1,100.75,25.833V74.722A12.221,12.221,0,0,1,88.528,86.944H12.972A12.221,12.221,0,0,1,.75,74.722V25.833A12.221,12.221,0,0,1,12.972,13.611H26.928Zm1.6,6.667H12.972a5.558,5.558,0,0,0-5.556,5.556V74.722a5.558,5.558,0,0,0,5.556,5.556H88.528a5.558,5.558,0,0,0,5.556-5.556V25.833a5.558,5.558,0,0,0-5.556-5.556H72.972a3.35,3.35,0,0,1-2.6-1.249l-6.884-8.613a3.35,3.35,0,0,0-2.6-1.249H40.621a3.35,3.35,0,0,0-2.6,1.249l-6.884,8.613a3.35,3.35,0,0,1-2.6,1.249Z",
    fill: "#e8eaf0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M13.083,11.667a3.333,3.333,0,0,1,0-6.667H26.417a3.333,3.333,0,0,1,0,6.667Z",
    transform: "translate(31 8.611)",
    fill: "#e8eaf0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 23.333,
    cy: 23.333,
    r: 23.333,
    transform: "translate(27.417 26.944)",
    fill: "#e8eaf0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.8a50599f47f371f2076c0f23e600596a.svg";
export { ForwardRef as ReactComponent };